import { BaseError } from '@nsftx/seven-client-retail-utils'
import type { AppBootstrapErrorType } from '@/types/AppBootstrapErrorTypes'

export default class AppBootstrapError extends BaseError<AppBootstrapErrorType> {
  constructor(
    public message: string,
    public code: AppBootstrapErrorType,
    public options?: {
      cause?: unknown
    }
  ) {
    super(message, code, options)
    Object.setPrototypeOf(this, AppBootstrapError.prototype)
    this.name = this.constructor.name
  }
}
